import { exportLabels } from '../constants/exportLabels';
import type { ReportProblem } from '../types';

const EXPORT_ERROR = 'com.mylaborelec.api.exports.';

const MESSAGES_BY_STATUS: Record<number, string> = {
  404: exportLabels.error_not_found,
  409: exportLabels.error_no_up_to_date_results,
  413: exportLabels.error_too_large,
  422: exportLabels.error_invalid_request,
  500: exportLabels.error_failed,
  503: exportLabels.error_busy,
};

/** Readable message chosen from the error `type` first, then the HTTP status; server text is never shown. */
export const exportErrorMessage = (problem: ReportProblem): string => {
  if (problem.type === `${EXPORT_ERROR}busy` && problem.retryAfterSeconds) {
    return exportLabels.error_busy_retry_after(problem.retryAfterSeconds);
  }
  return (problem.status ? MESSAGES_BY_STATUS[problem.status] : undefined) ?? exportLabels.error_unknown;
};
